import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Header from "./Includes/Header";
import Footer from "./Includes/Footer";
import HelpBtn from "./Includes/HelpBtn";
import Spacer from "MyComponents/UI/Spacer";
import user_icon from "../images/reg_user.png";

import AccountSecuritySection from "MyComponents/AccountSecuritySection";
import UserProfilesSection from "MyComponents/UserProfilesSection";
import { notifyError, ToastBox } from "MyComponents/Toaster";
import { SpinnerBox } from "./Spinner";

const UserProfilePage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const startLoading = () => setLoading(true);
  const stopLoading = () => setLoading(false);
  const [activeTab, setActiveTab] = useState<"profile" | "security">("profile"); // TAB STATE

  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "visible";
  }, [loading]);

  return (
    <>
      <ToastBox />
      <Header />
      {loading && <SpinnerBox />}
      <Container fluid>
        <Row className="px-5 mt-4">
          <Spacer height="30px" />
        </Row>

        <Row className="px-5">
          <Col md={12} className="text-center">
            <img src={user_icon} width={50} alt="user" />
            <h3 className="text-center mt-3">User Profiles</h3>
          </Col>
        </Row>

        <Row>
          <Col md={3}></Col>
          <Col md={6} className="mb-5 mt-4 rounded-3">
            
            {/* TAB BUTTONS */}
            <div className="d-flex justify-content-center gap-3 mb-4">
              <Button
                variant={activeTab === "profile" ? "dark" : "outline-secondary"}
                className="rounded-pill px-4"
                onClick={() => setActiveTab("profile")}
              >
                User Profile
              </Button>
              <Button
                variant={activeTab === "security" ? "dark" : "outline-secondary"}
                className="rounded-pill px-4"
                onClick={() => setActiveTab("security")}
              >
                Account Security
              </Button>
            </div>

            {/* CONDITIONAL RENDERING */}
            {activeTab === "profile" && <UserProfilesSection />}
            {activeTab === "security" && <AccountSecuritySection />}
          </Col>
          <Col md={3}></Col>
        </Row>
      </Container>

      <HelpBtn />
      <Footer full />
    </>
  );
};

export default UserProfilePage;
